import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ChartSkeleton = () => {
    return (
        <div className="flex items-center m-5 gap-5">
            <div className="w-1/3 mr-8 max-[1200px]:w-1/2">
                <Skeleton
                    width={172}
                    height={172}
                    style={{ borderRadius: "50%" }}
                />
            </div>
            <div className="w-1/3 flex flex-col gap-5">
                <p>
                    <Skeleton height={15} />
                </p>
                <p>
                    <Skeleton height={15} />
                </p>
                <p>
                    <Skeleton height={15} />
                </p>
                <p>
                    <Skeleton height={15} />
                </p>
                <p>
                    <Skeleton height={15} />
                </p>
                <p>
                    <Skeleton height={15} />
                </p>
                <p>
                    <Skeleton height={15} />
                </p>
            </div>
        </div>
    );
};

export default ChartSkeleton;
